import { useState } from "react";
import { toast } from "react-toastify";
import PageHeader from "../../Component/PageHeader";
import { ADMINS, AUDIT, AUDIT_ACTIONS } from "../../utils/staticData";

// STATIC DESIGN — replace AUDIT with the audit-log API. The log is read-only by design.

// "field old → new" → field + struck-through old value + new value
const Diff = ({ text }: { text: string }) => {
  const m = text.match(/^(.+?) (\S+) → (\S+)$/);
  if (!m) return <div className="cx-diff">{text}</div>;
  return <div className="cx-diff">{m[1]} <span className="o">{m[2]}</span> → <span className="n">{m[3]}</span></div>;
};

const AuditLog = () => {
  const [search, setSearch] = useState("");
  const [admin, setAdmin] = useState("all");
  const [action, setAction] = useState("all");

  const rows = AUDIT.filter(([, who, act, target, meta, diff]) =>
    (admin === "all" || who === admin) &&
    (action === "all" || (act + " " + diff).toLowerCase().includes(action.toLowerCase().slice(0, 5))) &&
    (!search || (who + act + target + meta).toLowerCase().includes(search.toLowerCase()))
  );

  const exportCsv = () => {
    const csv = [["Admin", "Action", "Target", "When / details", "Change"], ...rows.map(r => r.slice(1))]
      .map(r => r.map(x => `"${String(x).replace(/"/g, '""')}"`).join(",")).join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = "uomox-audit-log.csv";
    a.click();
    URL.revokeObjectURL(a.href);
    toast.success("Audit log exported");
  };

  return (
    <div className="container-fluid">
      <div className="cx">
        <PageHeader
          crumb="Audit log"
          title="Audit log"
          sub="Every admin action — who, when and what changed. It can be exported, never deleted."
          actions={<button type="button" className="cx-btn cx-btn-light" onClick={exportCsv}><i className="ri-download-2-line"></i>Export</button>}
        />

        <div className="cx-card">
          <div className="cx-toolbar">
            <input className="cx-input" type="search" placeholder="Search admin, client, action…" value={search} onChange={(e) => setSearch(e.target.value)} />
            <select className="cx-select" value={admin} onChange={(e) => setAdmin(e.target.value)}>
              <option value="all">All admins</option>
              {ADMINS.map(a => <option key={a[0]} value={a[0]}>{a[0]}</option>)}
            </select>
            <select className="cx-select" value={action} onChange={(e) => setAction(e.target.value)}>
              <option value="all">All actions</option>
              {AUDIT_ACTIONS.map(a => <option key={a} value={a}>{a}</option>)}
            </select>
          </div>
          <div className="cx-card-b" style={{ padding: 18 }}>
            {rows.length ? (
              <div className="cx-timeline">
                {rows.map(([tone, who, act, target, meta, diff], i) => (
                  <div className={`cx-tl ${tone}`} key={i}>
                    <div className="t"><b>{who}</b> {act} <b>{target}</b></div>
                    <div className="m">{meta}</div>
                    {diff && <Diff text={diff} />}
                  </div>
                ))}
              </div>
            ) : <div className="cx-empty"><i className="ri-history-line"></i>No audit entries match these filters.</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditLog;
